//RAW DATA
export const GET_SELECTED_DEVICE_RAW_DATA = 'GET_DEVICE_RAW_DATA';
export const ERROR_SELECTED_DEVICE_RAW_DATA = 'ERROR_DEVICE_RAW_DATA';
export const CLEAR_SELECTED_DEVICE_RAW_DATA = 'CLEAR_DEVICE_RAW_DATA';
export const GET_BATTERY_ANALYSIS_GRAPH = 'GET_BATTERY_ANALYSIS_GRAPH';
export const ERROR_BATTERY_ANALYSIS_GRAPH = 'ERROR_BATTERY_ANALYSIS_GRAPH';